<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="512"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          class="ml-6"
          color="red-accent-4"
          append-icon="mdi-delete-outline"
          v-bind="props"
        >
          Excluir
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline"> Confirmação de Remoção </v-card-title>

        <v-card-text>
          Você tem certeza que deseja remover esta Area de Concentração?
        </v-card-text>

        <v-card-actions>
          <v-btn color="red darken-1" dark @click="submitForm">Sim</v-btn>
          <v-btn color="blue darken-1" dark @click="dialog = false">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  emits: ['areaConcentracaoRemovida'],
  data: () => ({
    dialog: false,
  }),
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    async submitForm() {
      try {
        const response = await axios.delete(
          // eslint-disable-next-line max-len
          `${apiUrl}/api/v1/areaConcentracao/${this.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        const idProjeto = this.$route.params.idProjeto;
        const idCharter = this.$route.params.id;

        this.$toast.success(response.data.msg);
        this.$emit('areaConcentracaoRemovida', idCharter);
        this.$router.push(`/projects/${idProjeto}/Charters/${idCharter}`);
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.dialog = false;
      }
    },
  },
};
</script>
